module.exports = __webpack_public_path__ + "static/media/Montag,_15._Juni_2009_(2).a2f11265.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_aus_frueheren_jahren/thumb/Montag,_15._Juni_2009_(2).jpg
// module id = 547
// module chunks = 0